// export const CORE_API_ENDPOINT = 'http://localhost:2701'
// export const CORE_API_ENDPOINT = `https://dtacbainisys.com/core`
export const CORE_API_ENDPOINT = `/api`
// export const CORE_API_ENDPOINT = `https://dtacuat-front.rmbainisys.com/api`
// export const CORE_API_ENDPOINT = `https://aji-meetingroom.bainisyspro.com/api`

export const O365_API_ENDPOINT = 'http://localhost:3000/o365'


// WEBPACK FOOTER //
// ./src/lib/api.js